import Vue from 'vue'
import VueRouter from 'vue-router'
import Grid from '../views/Grid.vue'
import Document from '../views/Document.vue'
import LoginForm from '../views/account/LoginForm.vue'
import Unauthorized from '../views/Unauthorized.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Grid,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'LoginForm',
    component: LoginForm,
  },
  {
    path: '/document/:id',
    name: 'DocumentPage',
    component: Document,
    meta: { requiresAuth: true },
  }, 
  {
    path:'/unauthorized', 
    name: 'Unauthorized', 
    component: Unauthorized
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    const loggedIn = localStorage.getItem('user');
    if (!loggedIn) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router
